module.exports = __webpack_public_path__ + "img/1zoolMov.0d056716.png";